import { Box, Paper, Skeleton, Stack } from "@mui/material";

type PageSkeletonProps = {
  variant?: "table" | "cards" | "dashboard";
  compact?: boolean;
};

const PageSkeleton = ({
  variant = "table",
  compact = false,
}: PageSkeletonProps) => {
  if (compact) {
    return (
      <Stack spacing={1.5} width="100%" py={2}>
        <Skeleton variant="rounded" height={48} />
        <Skeleton variant="rounded" height={48} />
        <Skeleton variant="rounded" height={48} width="72%" />
      </Stack>
    );
  }

  return (
    <Box sx={{ width: "94%", mx: "auto", py: { xs: 2, sm: 3 } }}>
      <Paper sx={{ p: 2.5, mb: 2.5, borderRadius: "20px" }}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Skeleton variant="rounded" width={48} height={48} />
          <Box flex={1}>
            <Skeleton height={32} width="28%" />
            <Skeleton height={20} width="45%" />
          </Box>
          <Skeleton
            variant="rounded"
            width={120}
            height={42}
            sx={{ display: { xs: "none", sm: "block" } }}
          />
        </Stack>
      </Paper>

      {variant === "cards" ? (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: 2,
          }}
        >
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton key={index} variant="rounded" height={190} />
          ))}
        </Box>
      ) : variant === "dashboard" ? (
        <>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
              gap: 2,
              mb: 2,
            }}
          >
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} variant="rounded" height={140} />
            ))}
          </Box>
          <Skeleton variant="rounded" height={300} />
        </>
      ) : (
        <Paper sx={{ p: 2, borderRadius: "18px" }}>
          <Skeleton variant="rounded" height={48} sx={{ mb: 1.5 }} />
          {Array.from({ length: 7 }).map((_, index) => (
            <Skeleton key={index} height={54} />
          ))}
        </Paper>
      )}
    </Box>
  );
};

export default PageSkeleton;
